import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle2, Scale } from 'lucide-react';
import { Button } from '../components/ui/button';
import { SeoHead, SEO_KEYWORDS_PRIMARY } from '../components/SeoHead';

export function ThankYouPage() {
  const location = useLocation();
  const uploadedFilesCount = Number(location?.state?.uploadedFilesCount || 0);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    window.gtag('event', 'conversion', {
      send_to: 'AW-16812833075',
      value: 1.0,
      currency: 'EUR',
    });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: '#0A192F' }}>
      <SeoHead
        title="Richiesta ricevuta | Lead Legale – infortunistica stradale e risarcimento danni"
        description="La tua richiesta è stata inviata correttamente. Ti ricontatteremo per consulenza legale e valutazione in ambito di infortunistica stradale e risarcimento danni."
        keywords={SEO_KEYWORDS_PRIMARY}
        path="/thank-you"
      />
      <div className="w-full max-w-2xl rounded-xl p-8 sm:p-10 text-center" style={{ backgroundColor: '#112240', border: '1px solid rgba(212, 175, 55, 0.35)' }}>
        <div className="flex items-center justify-center gap-2 mb-5">
          <Scale className="w-8 h-8" style={{ color: '#D4AF37' }} strokeWidth={1.5} />
          <span className="text-xl font-semibold" style={{ fontFamily: 'Playfair Display, serif', color: '#F8F9FA' }}>LeadLegale</span>
        </div>

        <CheckCircle2 className="w-14 h-14 mx-auto mb-4" style={{ color: '#22C55E' }} strokeWidth={1.6} />
        <h1 className="text-3xl sm:text-4xl font-medium mb-4" style={{ fontFamily: 'Playfair Display, serif', color: '#F8F9FA' }}>
          Richiesta Ricevuta con Successo
        </h1>
        <p className="text-sm sm:text-base mb-8" style={{ color: '#A0ABC0' }}>
          I nostri consulenti analizzeranno i dati inseriti. Riceverai un riscontro via email o telefono entro 24/48 ore lavorative.
        </p>
        {uploadedFilesCount > 0 && (
          <p className="text-sm sm:text-base mb-8" style={{ color: '#D4AF37' }}>
            Documentazione caricata con successo: {uploadedFilesCount} file allegati ricevuti.
          </p>
        )}
        {uploadedFilesCount === 0 && (
          <p className="text-sm sm:text-base mb-8" style={{ color: '#A0ABC0' }}>
            Richiesta registrata correttamente. Potrai integrare eventuali documenti nelle fasi successive.
          </p>
        )}

        <Link to="/">
          <Button className="btn-primary" style={{ backgroundColor: '#D4AF37', color: '#0A192F' }}>
            Torna alla Home
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default ThankYouPage;
